'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.percentToVW = exports.toPercent = exports.uiLayerShadow = exports.singleDirectionModuleSpacing = exports.setUiTransition = exports.FONT_FAMILIES = exports.setFontStack = exports.setFontSmoothing = exports.setFontSize = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  font-size: ', ';\n'], ['\n  font-size: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    -webkit-font-smoothing: ', ';\n    -moz-osx-font-smoothing: ', ';\n    text-shadow: 0 0 1px transparent;\n  '], ['\n    -webkit-font-smoothing: ', ';\n    -moz-osx-font-smoothing: ', ';\n    text-shadow: 0 0 1px transparent;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    transition: ', ' ', ' ease-out;\n  '], ['\n    transition: ', ' ', ' ease-out;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    margin-bottom: ', ';\n    margin-top: 0;\n  '], ['\n    margin-bottom: ', ';\n    margin-top: 0;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  box-shadow: 0 ', ' ', ' 0\n    ', ';\n'], ['\n  box-shadow: 0 ', ' ', ' 0\n    ', ';\n']);

var _styledComponents = require('styled-components');

var _Color = require('../core/Color');

var _Style = require('../core/Style');

var _misc = require('HubStyleTokens/misc');

var misc = _interopRequireWildcard(_misc);

var _sizes = require('HubStyleTokens/sizes');

var _theme = require('HubStyleTokens/theme');

var _times = require('HubStyleTokens/times');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var setFontSize = exports.setFontSize = function setFontSize(size) {
  return (0, _styledComponents.css)(_templateObject, (0, _Style.remCalc)(size));
};

var setFontSmoothing = exports.setFontSmoothing = function setFontSmoothing(smoothing) {
  var computedSmoothing = smoothing || 'antialiased';

  return (0, _styledComponents.css)(_templateObject2, computedSmoothing, computedSmoothing === 'antialiased' ? 'grayscale' : computedSmoothing);
};

// note: just a template literal, not using css function
var setFontStack = exports.setFontStack = function setFontStack(family) {
  return '\n  font-family: \'' + family + '\', ' + misc.FALLBACK_FONT_STACK + ';\n';
};

var FONT_FAMILIES = exports.FONT_FAMILIES = {
  bold: function bold() {
    return '\n        ' + setFontStack(misc.WEB_FONT_BOLD) + ';\n        font-weight: ' + misc.WEB_FONT_BOLD_WEIGHT + ';\n      ';
  },
  demibold: function demibold() {
    return '\n        ' + setFontStack(misc.WEB_FONT_DEMI_BOLD) + ';\n        font-weight: ' + misc.WEB_FONT_DEMI_BOLD_WEIGHT + ';\n      ';
  },
  medium: function medium() {
    return '\n        ' + setFontStack(misc.WEB_FONT_MEDIUM) + ';\n        font-weight: ' + misc.WEB_FONT_MEDIUM_WEIGHT + ';\n      ';
  },
  italic: function italic() {
    return '\n        ' + setFontStack(misc.WEB_FONT_ITALIC) + ';\n        font-style: italic;\n        font-weight: ' + misc.WEB_FONT_ITALIC_WEIGHT + ';\n      ';
  },
  default: function _default() {
    return '\n        ' + setFontStack(misc.WEB_FONT_REGULAR) + ';\n        font-weight: ' + misc.WEB_FONT_REGULAR_WEIGHT + ';\n      ';
  }
};

var setUiTransition = exports.setUiTransition = function setUiTransition(property, timing) {
  var computedTiming = timing || _times.MICRO_TRANSITION_TIMING;
  var computedProperty = property || 'all';

  return (0, _styledComponents.css)(_templateObject3, computedProperty, computedTiming);
};

var singleDirectionModuleSpacing = exports.singleDirectionModuleSpacing = function singleDirectionModuleSpacing(size) {
  var computedSize = size || parseInt(_sizes.BASE_SINGLE_DIRECTION_MARGIN, 10);
  return (0, _styledComponents.css)(_templateObject4, (0, _Style.remCalc)(computedSize));
};

var uiLayerShadow = exports.uiLayerShadow = function uiLayerShadow() {
  return (0, _styledComponents.css)(_templateObject5, _sizes.BASE_SHADOW_OFFSET_Y, _sizes.BASE_SHADOW_BLUR_RADIUS, (0, _Color.rgba)(_theme.BASE_SHADOW_COLOR, parseFloat(_sizes.BASE_SHADOW_ALPHA)));
};

var toPercent = exports.toPercent = function toPercent(value) {
  return value == null ? undefined : value + '%';
};

var percentToVW = exports.percentToVW = function percentToVW(width) {
  if (typeof width !== 'string') return width;
  return width.replace(/(\d+)%/g, '$1vw');
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/utils/Styles.js
// module id = 282
// module chunks = 0